import { render, staticRenderFns } from "./SectionRanking.vue?vue&type=template&id=48f78559&scoped=true&lang=pug&"
import script from "./SectionRanking.vue?vue&type=script&lang=js&"
export * from "./SectionRanking.vue?vue&type=script&lang=js&"
import style0 from "./SectionRanking.vue?vue&type=style&index=0&id=48f78559&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f78559",
  null
  
)

export default component.exports